{
  "marketing": {
    "footerProduct": "Prodotto",
    "navForDevelopers": "Per sviluppatori",
    "navForPm": "Per i PM",
    "navHome": "Home",
    "navOpenApp": "Apri l'app →",
    "navStart": "Inizia gratis →",
    "navPricing": "Prezzi"
  },
  "homepage": {
    "edition": "VOL. 1 · EDIZIONE 2026",
    "footerBlurb": "Un incubatore di idee agent-native. Costruito su un agente Rust self-hosted, Postgres + pgvector e ref su S3. SaaS closed-source — esporti i tuoi dati in markdown quando vuoi.",
    "footerSignIn": "ACCEDI",
    "footerGitHub": "GITHUB",
    "footerGoogle": "GOOGLE",
    "footerMagicLink": "LINK MAGICO",
    "footerEdition": "VOL. 1 · NUMERO 1 · EARLY ACCESS GLOBALE · EDIZIONE 2026",
    "footerPrivacy": "PRIVACY",
    "footerTerms": "TERMINI",
    "footerContact": "CONTATTI"
  }
}
